<script>
  import { getContext, createEventDispatcher } from "svelte";
  import { LOCATION } from "./contexts.js";
  import { push } from "./router.js";
  import { shouldNavigate } from "./utils.js";

  export let to = "/";
  export let replace = false;
 
  const location = getContext(LOCATION);
  const dispatch = createEventDispatcher();

  let href = to !== "/" ? ("#"+to) : "/";

  function onClick(event) {
    dispatch("click", event);

    if (shouldNavigate(event)) {
      event.preventDefault();
      // Don't push another entry to the history stack when the user
      // clicks on a Link to the page they are currently on.
      const shouldReplace = $location === href || replace;
      push(href, shouldReplace);
    }
  }
</script>

<a href="{href}" on:click="{onClick}">
  <slot></slot>
</a>
